// Local, bounded diagnostics: no URLs, query strings, payloads, names or tokens.
const records = [];
const installed = new WeakSet();
const reasons = new Set(['superseded', 'unmount', 'user', 'timeout']);
let activeAbortReason;
export const getCalendarRequestDiagnostics = () => records.map(record => ({ ...record }));
export const calendarCancellationReason = signal => reasons.has(signal?.reason)
  ? signal.reason : (activeAbortReason || 'caller_cancelled');
export const abortCalendarRequest = (request, reason) => {
  const previous = activeAbortReason;
  activeAbortReason = reasons.has(reason) ? reason : 'caller_cancelled';
  try { request.abort(activeAbortReason); } finally { activeAbortReason = previous; }
};

export const installCalendarRequestDiagnostics = client => {
  if (installed.has(client)) return;
  installed.add(client);
  if (typeof window !== 'undefined') window.getBeautiCalendarDiagnostics = getCalendarRequestDiagnostics;
  client.interceptors.request.use(config => {
    const endpoint = String(config.url || '').split('?')[0].match(/\/afterlogin\/appointment\/(resourceitems|nextresourceitemtime|view)$/)?.[1];
    if (!endpoint) return config;
    const requestId = `calendar-${globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(16).slice(2)}`}`;
    config.headers = config.headers || {};
    config.headers['X-Request-ID'] = requestId;
    const started = performance.now();
    let recorded = false;
    const finish = (outcome, status) => {
      if (recorded) return;
      recorded = true;
      config.signal?.removeEventListener('abort', onAbort);
      const record = { request_id: requestId, endpoint, outcome,
        duration_ms: Math.max(0, Math.round(performance.now() - started)),
        status: Number.isInteger(status) ? status : null };
      records.push(record);
      if (records.length > 100) records.shift();
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('beauti:calendar-request', {detail:{...record}}));
      }
    };
    const onAbort = () => finish(calendarCancellationReason(config.signal));
    config.calendarDiagnosticsFinish = finish;
    if (config.signal?.aborted) onAbort();
    else config.signal?.addEventListener('abort', onAbort, {once:true});
    return config;
  });
  client.interceptors.response.use(response => {
    response.config?.calendarDiagnosticsFinish?.('completed', response.status);
    return response;
  }, error => {
    const outcome = ['ECONNABORTED','ETIMEDOUT'].includes(error.code) ? 'timeout'
      : error.code === 'ERR_CANCELED' ? calendarCancellationReason(error.config?.signal) : 'failed';
    error.config?.calendarDiagnosticsFinish?.(outcome, error.response?.status);
    return Promise.reject(error);
  });
};
